import React, { Component } from "react";
import PropTypes from "prop-types";
import "bootstrap/dist/css/bootstrap.css";
import { NavLink } from "react-router-dom";
import Header from "./header";
import FileUpload from "../module/uploadFile";
import axios from "axios";
import Pagination from "../common/pagination";

class SupplierProductCard extends Component {
  render() {
    const { _id, supplier_name, ar_code, total_products } = this.props;
    // const [showPopup, setShowPopup] = false;

    // const slugifiedName = supplier_name.toLowerCase().replace(/[ .]/g, "-");
    // const client_name = encodeURIComponent(slugifiedName);

    return (
      <NavLink className="navlink" to={`/store/${_id}`}>
        {/* //  <NavLink className="navlink" to={`/store/${_id}`}> */}
        <div className="py-2 my-0">
          <div className="col card1 d-flex flex-wrap am-card justify-content-center">
            <div className="py-2 mb-1 text-center">
              {/* <h5>{name_cli}</h5> */}
              <h6>{supplier_name}</h6>
            </div>
            <div className="d-flex mb-2 mx-auto">
              <div className="px-3 mx-2 card new-bg">
                <span>{total_products}</span>
              </div>
            </div>
          </div>
        </div>
      </NavLink>
    );
  } 
}

SupplierProductCard.propTypes = { 
  ar_code: PropTypes.string.isRequired,   
  supplier_name: PropTypes.string.isRequired,   
}; 

class SupplierInventoryDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: "",
      setShowPopup: "",
      supplierdashboardlist: [],
      page: 1,
      setPage: "",
      setStores: "",
      loader: true,
      totalPage: 0,
      importLoading: false,
    };
    // this.getStores();
  }

  // handleSupplierExport = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_BASE_URL}/supplier/file/export`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("amira-token")}`,
  //         },
  //       }
  //     );
  //     const { status, data } = response.data || {};
  //     if (status === "Success" && Array.isArray(data) && data.length) {
  //       this.generateSupplierCSV(data);
  //     } else {
  //       alert("No new supplier data to export");
  //     }
  //   } catch (e) {
  //     console.log(e);
  //     alert("Export failed");
  //   }
  // };

  generateSupplierCSV = (data) => {
    const headers = [
      "supplier_id",
      "supplier_name",
      "ar_reference",
      "fo_raison_soc",
      "ar_code",
      "quantity",
      "required_quantity",
    ];

    const csvRows = [];
    csvRows.push(headers.join(","));
    data.forEach((row) => {
      csvRows.push(
        headers
          .map((field) => {
            const value = row[field];
            const safe = value === null || value === undefined ? "" : String(value);
            // Quote values containing commas or quotes
            if (/[",\n]/.test(safe)) {
              return '"' + safe.replace(/"/g, '""') + '"';
            }
            return safe;
          })
          .join(",")
      );
    });

    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "supplier-export.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  pageChange = (e) => {
    console.log(e);
    let p = e.target.attributes.getNamedItem("data-page").value;
    this.setState({
      page: Number(p),
    });
  };

  supplierHandleUploadClick = async () => {
    this.setState({
      showPopup: true,
      setShowPopup: true,
    });
    // this.supplierHandleUploadFiles(files);
    // const files = // Get the files you want to upload
    this.refs.fileUploader.click();
  };
  supplierHandleUploadFiles = async (files) => {
    this.setState({ importLoading: true });
    try {
      const formData = new FormData();

      for (let i = 0; i < files.length; i++) {
        formData.append("file", files[i]);
      }
      console.log(files);

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/supplier/file/import`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("amira-token")}`,
          },
        }
      );
      console.log(response.status);
      if (response.status === 200) {
        alert("File imported successfully");
        this.getStores();
      }
    } catch (e) {
      console.log(e);
    }finally {
      this.setState({ importLoading: false });
    }
  };

  getStores = async (search = false) => {
    try {
      let page = this.state.page;
      const response = await axios.get(
        `${
          process.env.REACT_APP_BASE_URL
        }/supplier/getsupplier-count/${page}?search=${search ? search : ""}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("amira-token")}`,
          },
        }
      );
      localStorage.setItem("searchDataValue", JSON.stringify(search));
      console.log(response.data.data);
      this.setState({
        supplierdashboardlist: response.data.data,
        totalPage: response.data.totalPage,
        loader: false,
      });
      let data = response.data;

      console.log("totalPage");
      console.log(data.totalPage);
      // this.state.setStores({
      //   stores: data.data,
      //   totalPage: data.totalPage,
      //   loader: false,
      // });
    } catch (err) {
      console.log(err);
    }
  };
  // componentDidMount = () => {

  //   this.getStores();
  // }
  componentDidMount() {
    this.getStores();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.page !== this.state.page) {
      this.getStores();
    }
  }

  render() {
    return (
      <div className="w-100">
        <Header />
        <div className="d-flex justify-content-end  my-3 mx-5">
          <div>
            {this.state.showPopup === true && (
              <div id="pop-up">
                <FileUpload />
              </div>
            )}{" "}
            {/* <img src={imageSrc} alt='logo' /> */}
          </div>
          <div className="d-flex justify-content-end">
            <button
              onClick={this.supplierHandleUploadClick}
              className="btn btn-bg mx-2 border rounded d-flex align-items-center gap-2 text-white"
              disabled={this.state.importLoading}
            >
              {this.state.importLoading && (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              )}
              <span>{this.state.importLoading ? 'Importing...' : 'Import'}</span>
            </button>
            {/* <button
              onClick={this.handleSupplierExport}
              className="btn btn-bg mx-2 border rounded"
            >
              Export
            </button> */}
            <input
              type="file"
              id="file"
              ref="fileUploader"
              accept=".csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              style={{ display: "none" }}
              onChange={(e) => {
                this.supplierHandleUploadFiles(e.target.files);
              }}
            />
            <input
              type="search"
              placeholder="Trouver"
              className="search-input btn me-2 border rounded-pill py-2  text-black "
              onChange={(e) => {
                this.getStores(e.target.value);
              }}
              name="SearchStore"
            ></input>
          </div>
        </div>

        {this.state.supplierdashboardlist?.length === 0 ? (
          this.state.loader ? (
            <div className="text-center p-4">
              <div className="loader1">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          ) : (
            <div className="d-flex">
              <p className="mx-auto">Aucun Enregistrement Trouvé.</p>
            </div>
          )
        ) : (
          <div className="d-flex flex-wrap mx-5 mb-5">
            {this.state.supplierdashboardlist?.map((product, index) => (
              <div
                key={product?.supplier_id || "test" + index}
                className="col-lg-2 col-md-3 col-sm-4 col-6 tsw-list-card card"
              >
                <SupplierProductCard
                  _id={product.supplier_id}
                  supplier_name={product.fo_raison_soc}
                  ar_code={product.ar_code}
                  total_products={product.total_products}
                />
                {(index + 1) % 5 === 0 && <div className="w-100"></div>}
              </div>
            ))}
          </div>
        )}

        {this.state.supplierdashboardlist?.length === 0 ? (
          ""
        ) : (
          <div className="mt-2 pagination justify-content-center d-none">
            {/* <div className='page-item'> */}
            <Pagination
              page={this.state.page}
              pageChange={this.pageChange}
              totalPage={this.state.totalPage}
            />
            {/* </div> */}
          </div>
        )}
      </div>
    );
  } 
}
export default SupplierInventoryDashboard;
